<template>
  <form id="resetForm" class="reset-container m-t animated fadeInUp" action="#" @submit.prevent @keyup.enter="resetPassword">
    <v-layout row wrap class="mx-0">
      <!-- title -->
      <v-flex xs12 tag="h3">
        {{ $t("view.login.forgetPwd.title") }}
      </v-flex>

      <!-- Sub title instructions -->
      <v-flex xs12>
        <v-subheader>{{ $t("view.login.forgetPwd.instructions") }}</v-subheader>
      </v-flex>

      <!-- USERNAME INPUT -->
      <v-flex xs12>
        <v-text-field
          v-model="auth.username"
          prepend-icon="person"
          :label="$t('view.login.signin.username.placeholder')"
          type="text"
          :loading="view.action.resetPassword.busy"
          :error-messages="$t(`validator.${getFirstError($v.auth.username)}.text`, '')" />
      </v-flex>

      <!-- ERROR MESSAGE -->
      <v-flex xs12 class="pb-5">
        <label v-if="view.elem.label.resetPasswordError.visible" for="error" class="error--text">
          {{ errorResetPasswordMessage }}
        </label>
      </v-flex>

      <!-- SUBMIT BUTTON -->
      <v-flex xs12>
        <v-btn :disabled="hasErrors($v.auth)" name="loginSubmit" block color="primary" :loading="view.action.resetPassword.busy" @submit="resetPassword()" @click="resetPassword()">
          {{ $t("view.login.forgetPwd.submit") }}
        </v-btn>
      </v-flex>

      <!-- RESET PASSWORD LINK -->
      <v-flex xs12 class="py-3">
        <router-link :to="{ name: 'SignIn' }" :disabled="view.action.resetPassword.busy">
          <small>{{ $t("view.login.forgetPwd.cancel") }}</small>
        </router-link>
      </v-flex>
    </v-layout>
  </form>
</template>
<script>
import Auth from "@/services/auth";
import { AuthenticationModel } from "@/models/authentication";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { valueIsWithin } from "@/helpers/validators";
import { required } from "vuelidate/lib/validators";

const label = {
  resetPasswordError: {
    visible: false
    , text: ""
  }
};
const button = { resetPassword: { enable: true } };

const action = { resetPassword: { busy: false } };

export default {
  name: "ForgetPasswordModule"
  , data() {
    return {
      auth: undefined
      , view: {
        title: this.$t("view.login.forgetPwd.title")
        , action
        , elem: {
          label
          , button
        }
      }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , computed: {
    errorResetPasswordMessage() {
      return this.view.elem.label.resetPasswordError.text;
    }
  }
  , created() {
    this.setInitialState();
  }
  , methods: {
    ...allValidatorMethods
    , async resetPassword() {
      try {
        // Hide any previous error
        this.hideErrorResetPassword();
        // Validate all models before make the request
        if (!this.isAllValid(this.$v)) return;

        this.view.action.resetPassword.busy = true;
        // Calling API to request a reseting
        const response = await Auth.requestResetPassword(this.auth);
        this.view.action.resetPassword.busy = false;
        this.$router.push({ name: "ForgetPwdMessage", params: { username: this.auth.username, nombre: response.data.body.results.nombre } });
      } catch (error) {
        console.log(error);
        this.view.action.resetPassword.busy = false;
        if (error && (error.status == "500" || error.status == "403")) this.showErrorResetPassword(this.$t(`errors.network.${error.status}.desc`));

        const { data: { meta: { code: errorCode } } } = error;

        const login = this.$t("view.login");

        // List of errors required for changing password flow
        const errorsResetPassword = Object.keys(login.resetPassword);
        const errorsChangePassword = Object.keys(login.changePassword);
        const errorsLogin = Object.keys(login.auth);

        // Error's reseting password
        if (valueIsWithin(errorsResetPassword, errorCode)) this.showErrorResetPassword(this.$t(`view.login.resetPassword.${errorCode}.text`));
        // Error's reseting password
        if (valueIsWithin(errorsChangePassword, errorCode)) this.showErrorResetPassword(this.$t(`view.login.changePassword.${errorCode}.text`));

        if (valueIsWithin(errorsLogin, errorCode)) this.showErrorResetPassword(this.$t(`view.login.auth.${errorCode}.text`));
      }
    }
    , showErrorResetPassword(message) {
      this.view.elem.label.resetPasswordError.visible = true;
      this.view.elem.label.resetPasswordError.text = message;
    }
    , hideErrorResetPassword() {
      if (!this.view.elem.label.resetPasswordError.visible) return;
      this.view.elem.label.resetPasswordError.visible = false;
      this.view.elem.label.resetPasswordError.text = "";
    }
    , setInitialState() {
      this.auth = new AuthenticationModel();
      this.view.elem.label.resetPasswordError.visible = false;
      this.view.elem.label.resetPasswordError.text = "";
    }
  }
  , validations: { auth: { username: { required } } }
};
</script>

<!-- Style scoped Implementation -->
<style scoped>
.reset-container {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ForgetPassword.vue